import { useTranslation } from "react-i18next";
import { ExploreReveal } from "./ExploreReveal";

export function ExploreTenantBridge() {
  const { t } = useTranslation();

  return (
    <section className="explore-section explore-section--surface-blue explore-section--bridge">
      <div className="explore-section-inner explore-bridge-layout">
        <ExploreReveal>
          <p className="explore-kicker">{t("Explore_Bridge_Kicker")}</p>
          <h2 className="explore-display-title">{t("Explore_Bridge_Title")}</h2>
          <p className="explore-lead">{t("Explore_Bridge_Body")}</p>
        </ExploreReveal>

        <ExploreReveal className="explore-bridge-visual" delayMs={160} aria-hidden>
          <div className="explore-bridge-pill">{t("Explore_Bridge_Owner")}</div>
          <div className="explore-bridge-connector">
            <span className="explore-bridge-pulse" />
          </div>
          <div className="explore-bridge-pill explore-bridge-pill--accent">
            {t("Explore_Bridge_Tenant")}
          </div>
        </ExploreReveal>
      </div>
    </section>
  );
}
